<div class="rules-dialog"
  [ngClass]="{'denied' : gameManager.stateManager.permissions && !gameManager.stateManager.permissions.scenario}">
  @for (ruleModel of gameManager.game.scenarioRules | trackUUID; track ruleModel._trackUUID; let index = $index) {
  @if (visible(index)) {
  <div class="rule-dialog dialog" #ruleElement>
    <div class="dialog-container">
      <div class="hide" (click)="hideRule(ruleElement, index)"><span [ghs-label]="'scenario.rules.hide'"></span>
        <img src="./assets/images/close.svg">
      </div>
      <ghs-scenario-rule [rule]="ruleModel.rule" [identifier]="ruleModel.identifier"></ghs-scenario-rule>
      @if (apply(ruleModel.rule)) {
      <div class="menu">
        <a class="apply" (click)="applyRule(ruleElement, index)">
          <span
            [ghs-label]="ruleModel.rule.alwaysApply || ruleModel.rule.alwaysApplyTurn ? 'scenario.rules.alwaysApply' : 'scenario.rules.apply'"></span>
          <img src="./assets/images/check.svg">
        </a>
      </div>
      }
      <div class="close" (click)="close(ruleElement, index)" [ghs-label]="'scenario.rules.dismiss'"
        [ghs-label-attribute]="'title'"></div>
    </div>
  </div>
  }
  }
</div>